import React from "react";
import DashboardLayout from "../layouts/DashboardLayout";

const Dashboard = () => {
  return (
    <div className="p-8 bg-gray-100">
      <DashboardLayout />
    </div>
  );
};

export default Dashboard;
